import * as React from "react";
var toastStackContext = React.createContext(null);
export var ToastStackProvider = toastStackContext.Provider;
export function useToastStack() {
    return React.useContext(toastStackContext);
}
//# sourceMappingURL=toastStackContext.js.map